// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("@img/box-checkmark.svg");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
exports.push([module.id, ".bottom-label[data-v-24865d6f]{padding-left:35px;font-weight:500;font-size:14px}.dialog-image-box[data-v-24865d6f]{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ");background-position:10px 130px;background-size:290px}", ""]);
// Exports
module.exports = exports;
